var CUJEvents = /* @__PURE__ */ ((CUJEvents2) => {
  CUJEvents2["SDK_INIT"] = "sdk_init";
  CUJEvents2["FETCH_DATA"] = "fetch_data";
  CUJEvents2["SUBSCRIBE_EVENT"] = "subscribe_event";
  CUJEvents2["UNSUBSCRIBE_EVENT"] = "unsubscribe_event";
  CUJEvents2["GET_RECORD"] = "get_record";
  CUJEvents2["FETCH_RECORD"] = "fetch_record";
  CUJEvents2["GET_RECORDS"] = "get_records";
  CUJEvents2["FETCH_RECORDS"] = "fetch_records";
  CUJEvents2["GET_ENTITY"] = "get_entity";
  CUJEvents2["FETCH_ENTITY"] = "fetch_entity";
  CUJEvents2["GET_ENTITIES"] = "get_entities";
  CUJEvents2["FETCH_ENTITIES"] = "fetch_entities";
  CUJEvents2["FETCH_COLLECTION_POINT"] = "fetch_collection_point";
  CUJEvents2["GET_COLLECTION_POINT"] = "get_collection_point";
  CUJEvents2["UPDATE_RECORD"] = "update_record";
  CUJEvents2["UPDATE_RECORDS_BY_COLLECTION_POINT"] = "update_records_by_collection_point";
  return CUJEvents2;
})(CUJEvents || {});
const TEA_EVENT_NAME_MAPPING = {
  ["sdk_init" /* SDK_INIT */]: "consent_init_sdk",
  ["fetch_data" /* FETCH_DATA */]: "consent_fetch_data",
  ["subscribe_event" /* SUBSCRIBE_EVENT */]: "consent_subscribe_event",
  ["unsubscribe_event" /* UNSUBSCRIBE_EVENT */]: "consent_unsubscribe_event",
  ["fetch_record" /* FETCH_RECORD */]: "consent_fetch_record",
  ["fetch_records" /* FETCH_RECORDS */]: "consent_fetch_records",
  ["get_record" /* GET_RECORD */]: "consent_get_record",
  ["get_records" /* GET_RECORDS */]: "consent_get_records",
  ["fetch_entity" /* FETCH_ENTITY */]: "consent_fetch_entity",
  ["fetch_entities" /* FETCH_ENTITIES */]: "consent_fetch_entities",
  ["get_entity" /* GET_ENTITY */]: "consent_get_entity",
  ["get_entities" /* GET_ENTITIES */]: "consent_get_entities",
  ["fetch_collection_point" /* FETCH_COLLECTION_POINT */]: "consent_fetch_collection_point",
  ["get_collection_point" /* GET_COLLECTION_POINT */]: "consent_get_collection_point",
  ["update_records_by_collection_point" /* UPDATE_RECORDS_BY_COLLECTION_POINT */]: "consent_update_records_by_collection_point",
  ["update_record" /* UPDATE_RECORD */]: "consent_create_record_api"
};
export {
  CUJEvents,
  TEA_EVENT_NAME_MAPPING
};
